/**
 * Return `url` only if it is an http(s) URL, else `undefined`.
 *
 * React does not sanitize the `href` attribute, so a value beginning with
 * `javascript:` executes on click. The MR URL rendered on the detail pages is
 * minted by the BFF (not directly user-authored), but this closes the scheme
 * hole cheaply — an anchor with an `undefined` href renders as inert text.
 */
export function safeHttpUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  try {
    const { protocol } = new URL(url);
    return protocol === "http:" || protocol === "https:" ? url : undefined;
  } catch {
    return undefined;
  }
}
